import { render, staticRenderFns } from "./SidebarBasic.vue?vue&type=template&id=7a59d28d&"
import script from "./SidebarBasic.vue?vue&type=script&lang=js&"
export * from "./SidebarBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports